import type { Contact } from "~/components/header/types"
import Icon, { type AvailableIcons } from "~/components/ui/Icon"

export default function Contact({ label, phone, icon, url }: Contact) {
    const Component = url ? 'a' : 'div'
    const props = url ? { href: url, target: '_blank' } : {}

    return (
        <Component
            {...props}
            className='h-12 gap-1.5 border border-white flex items-center justify-center lg:h-auto lg:border-none lg:gap-2'
        >
            <Icon id={icon as AvailableIcons} size={20} />
            <span>{label}</span>
            {phone && <span className='text-lg font-bold lg:text-sm'>{phone}</span>}
        </Component>
    )
}
